function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.106,100H3c-1.656,0-3-1.343-3-3V3c0-1.657,1.344-3,3-3h75.106c1.657,0,3,1.343,3,3v94 C81.106,98.657,79.763,100,78.106,100 M6,94h69.105V6H6V94z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.136,34.896h-2.634c-1.656,0-3-1.343-3-3c0-1.656,1.344-3,3-3h2.634c1.657,0,3,1.344,3,3 C26.136,33.553,24.793,34.896,23.136,34.896"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.136,53h-2.634c-1.656,0-3-1.344-3-3c0-1.657,1.344-3,3-3h2.634c1.657,0,3,1.343,3,3 C26.136,51.656,24.793,53,23.136,53"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.136,71.104h-2.634c-1.656,0-3-1.344-3-3c0-1.657,1.344-3,3-3h2.634c1.657,0,3,1.343,3,3 C26.136,69.761,24.793,71.104,23.136,71.104"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.603,34.896H35.407c-1.657,0-3-1.343-3-3c0-1.656,1.343-3,3-3h25.196c1.657,0,3,1.344,3,3 C63.603,33.553,62.26,34.896,60.603,34.896"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.603,53H35.407c-1.657,0-3-1.344-3-3c0-1.657,1.343-3,3-3h25.196c1.657,0,3,1.343,3,3 C63.603,51.656,62.26,53,60.603,53"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M60.603,71.104H35.407c-1.657,0-3-1.344-3-3c0-1.657,1.343-3,3-3h25.196c1.657,0,3,1.343,3,3 C63.603,69.761,62.26,71.104,60.603,71.104"
});

var SvgCircolari = function SvgCircolari(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 101,
    viewBox: "-0.514 -0.752 82 101",
    enableBackground: "new -0.514 -0.752 82 101",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCircolari, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circolari.16a1b881.svg";
export { ForwardRef as ReactComponent };